import React from "react";

export default class WhiteLogo extends React.PureComponent {
    render() {
        return (
            <div className={'logo-white'}>
                <img alt={'Soundslates'} src={require('../../assets/images/logo-white-2.png')}/>

            </div>
        );
    }
}

